import { styled, useDimension } from '@openeducation/oe-it-themes';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { UseMutateFunction } from 'react-query';

import FeedbackActions from './feedback-actions';
import FeedbackForm from './feedback-form';
import { OEText } from '../../../atoms';

interface FeedbackDialogContentProps {
  nlsKeys: {
    title?: string;
    instructions?: string;
    enterText?: string;
  };
  isLoading: boolean;
  onClose: () => void;
  onSubmit: UseMutateFunction<Response, unknown, string, unknown>;
}

export default function FeedbackDialogContent({
  nlsKeys,
  isLoading,
  onClose,
  onSubmit,
}: FeedbackDialogContentProps) {
  const { isLargeScreen } = useDimension();
  const [message, setMessage] = useState('');
  const { t } = useTranslation();

  return (
    <Container isLargeScreen={isLargeScreen}>
      {nlsKeys.title && (
        <TitleContainer>
          <OEText fontSize={20} fontType="bold">
            {t(nlsKeys.title)}
          </OEText>
        </TitleContainer>
      )}

      <FeedbackForm
        nlsKeys={nlsKeys}
        value={message}
        onChangeText={setMessage}
      />

      <FeedbackActions
        disabled={!message.trim()}
        isLoading={isLoading}
        onClose={onClose}
        onSubmit={() => onSubmit(message)}
      />
    </Container>
  );
}

const Container = styled.View<{ isLargeScreen: boolean }>`
  flex: 1;
  width: 100%;
  margin-vertical: 48px;
  padding-horizontal: ${({ isLargeScreen }) => (isLargeScreen ? 32 : 24)}px;
`;

const TitleContainer = styled.View`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-horizontal: 0;
  margin-bottom: 16px;
`;
